<template>
	<div class="tree-menu-page">
		<div class="search-wrapper">
			<span class="search-input" @click="goSearch"><img class="search-icon" src="/static/images/Icon_Search.png"><em>你有什么想了解的？</em></span>
		</div>
		<div class="WTF">
			<div class="tree-menu-wrapper" id="tree-menu-wrapper">
				<transition name="tag-list">
					<div class="tag-list-wrapper tag-list-wrapper-fixed" v-if="showTagList">
						<div class="tag-list">
							<span class="tag" @click="getMenuData(tag,index)" :class="{'active-tag':tag.Selected && tagIndex == index}" v-for="(tag, index) in tagsList" :key="index">
								<i v-text="tag.Name"></i>
							</span>
						</div>
					</div>
				</transition>
				<transition name="tag-title">
					<div class="tag-title-wrapper tag-title-wrapper-fixed" @click="showTagList = true" v-if="!showTagList && showTagTitle">
						<span class="tag-title" v-text="tagsList[tagIndex].Name"></span><span class="icon-triangle-active"></span>
					</div>
				</transition>
				<div class="menu-wrapper">
					<div class="tag-list-wrapper" id="tag-list-wrapper">
						<div class="tag-list">
							<span class="tag" @click="getMenuData(tag,index)" :class="{'active-tag':tag.Selected && tagIndex == index}" v-for="(tag, index) in tagsList" :key="index">
								<i v-text="tag.Name"></i>
							</span>
						</div>
					</div>
					<div class="collapse-wrapper">
						<transition name="upDown">
							<menu-folder v-if="menuData.length > 0 && ajaxDone" :LogId="LogId" :menuData="menuData" :colIndex="0"></menu-folder>
						</transition>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import menuFolder from './menuFolder'
	import store from '../../store/index'
	import {
		HOME,COMMON
	} from '../../api'
    export default {
		name: "treeMenu",
		data(){
			return {
			    LogId:'',
				showTagList:false,
				showTagTitle:false,
				tagsList:null,
				tagIndex:null,
				ajaxDone:false
			}
		},
		components:{
			menuFolder
		},
		activated() {
			setTimeout(() => {
                if(document.querySelector('.KB-locat')) document.querySelector('.KB-locat').scrollIntoViewIfNeeded(true);
			}, 300);
		},
		mounted() {
			this.getMenuData()
			document.getElementById('tree-menu-wrapper').addEventListener(
				"scroll",
				() => {
					this.scrollHandler();
				},
				false
			);
		},
		destroy() {
			document.getElementById('tree-menu-wrapper').removeEventListener(
				"scroll",
				() => {
					this.scrollHandler();
				},
				false
			);
		},
		methods: {
			scrollHandler(){
				let scrollH = document.getElementById('tree-menu-wrapper').scrollTop
				let tagH = document.getElementById('tag-list-wrapper').offsetHeight
				this.showTagList = false;
				this.showTagTitle = !!(scrollH > tagH )
			},
			getMenuData(tag,index){
				let data = null;
				this.ajaxDone = false
				if(tag){
                    store.commit('SET_CurrentNode','')
					data = {
						NodeId: tag.NodeId
					}
				}else{
					data= {
						// KBInfoId: store.state.menu.KBInfoId
						KBInfoId: ''
					}
				}
				HOME.GetNodeListMap(data).then(res=>{
					this.tagsList = res.Data.ParentList
					this.tagsList.map((e,i)=>{
						if(e.Selected) {
                            this.getLogId(e)
							if(tag) {
							    //这里是点击一级目录
								this.tagIndex = i
								this.ajaxDone = true

							}else{
                                //这里是第一次进来
							    setTimeout(() => {
									this.tagIndex = i
									this.ajaxDone = true

								}, 500);
							}
						}
					})
					store.state.menu.menuList = res.Data.ChildList;
				}).catch(()=>{
					this.ajaxDone = true
				})
			},
			goSearch(){
                this.$router.push({ name: 'searchKnowledge'} )
			},

            //获取logid  埋点方法
            getLogId(node){
                try{
                    let data = {
                        Origin:'Node',
                        NodeId:node.NodeId,
                        NodeName:node.Name
                    }
                    COMMON.AddNodeViewData(data).then((res)=>{
                        this.LogId = res.Data.LogId
                    })
                }
                catch (e) {
                    console.log(e);
                }
            }
		},
		watch: {
            '$route' (to, from) {
				if(from.name !== 'home') return
				this.showTagList= false
				this.showTagTitle= false
				this.tagsList= null
				this.tagIndex= null
				this.ajaxDone= false
				this.getMenuData()
            }
        },
        computed:{
			menuData(){
				return store.state.menu.menuList
			}
        }
    }
</script>

<style lang="scss" scoped>
@keyframes showUpSlowly {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
.tree-menu-page{
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
	.search-wrapper{
		height: j(130);
		background-color: #ffffff;
		border-bottom: 1px solid #F0F1F2;
		padding-top: j(20);
		box-sizing: border-box;
		position: relative;
		z-index: 100;
		opacity: 1;
		.search-input{
			display: block;
			background-color: #F7F7F8;
			margin: 0 auto;
			height: j(90);
			width: j(650);
			display: flex;
			align-items: center;
			.search-icon{
				height: j(48);
				width: j(48);
                margin-left: j(20);
                margin-right: j(25);
            }
            em {
                font-style: unset;
                font-size: j(36);
                color: #cdced4;
            }
		}
	}
	.WTF{
		flex: 1;
		width: 100%;
		overflow: hidden;
	}
	.tree-menu-wrapper {
		height: 100%;
		width: 100%;
		background-color: #fff;
		overflow: scroll;
		.tag-list-wrapper{
			width: 100%;
			padding:j(30) j(50) 0;
			box-sizing: border-box;
			border-bottom: 1px solid #F0F1F2;
			background-color: #fff;
			.tag-list{
				display: flex;
				flex-wrap: wrap;
				margin: 0 j(-35);
				.tag{
					margin: 0 j(35) j(30);
					position: relative;
					max-width: j(280);
					i{
						transition: all .3s linear;
						display: block;
						font-style: normal;
						height:j(40);
						line-height:j(40);
						color:rgba(51,51,51,1);
						font-size:j(28);
						font-weight:400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space:nowrap;
					}
				}
				.active-tag{
					i{
						color: #00bebe;
						&::after{
							content:'';
							display: block;
							position: absolute;
							top: j(-7);
							bottom: j(-5);
							left: j(-20);
							right: j(-20);
							border: 1px solid #00bebe;
							border-radius: j(25);
							animation: showUpSlowly .4s linear;
						}
					}
				}
			}
		}
		.tag-list-wrapper-fixed{
			position: fixed;
			top: j(130);
			left: 0;
			right: 0;
			z-index: 1;
			overflow: hidden;
		}
		.tag-title-wrapper-fixed{
			position: fixed;
			top: j(130);
			left: 0;
			right: 0;
			z-index: 1;
			background-color: #fff;
			z-index: 1;
			height: j(80);
			box-shadow:0px j(6) j(4) 0px rgba(147,122,122,0.1);
			display: flex;
			align-items: center;
			justify-content: center;
			.tag-title{
				font-size: j(28);
				color:#00bebe;
				max-width: j(400);
				overflow: hidden;
				text-overflow:ellipsis;
				white-space:nowrap
			}
			.icon-triangle-active{
				height: j(8);
				width: j(14);
				background-image: url('../../../static/images/arrow_up.png');
				background-repeat: no-repeat;
				background-size: contain;
				background-position: center;
				transform: rotateX(180deg);
				margin-left: j(10);
			}
		}
		.menu-wrapper{
			.collapse-wrapper{
				padding: j(20) j(50) 0 0;
				overflow: hidden;
			}
		}
	}
}


.tag-list-enter-active,.tag-list-leave-active{
	transition: all .2s linear;
}
.tag-list-enter,.tag-list-leave-to{
	transform: translateY(-100%);
	opacity: 0;
}

.tag-title-enter-active,.tag-title-leave-active{
	transition: all .2s linear;
}
.tag-title-enter,.tag-title-leave-to{
	opacity: 0;
}

.upDown-enter-active{
	transition: all .5s ease;
}
.upDown-leave-active{
	transition: all .1s linear;
}
.upDown-enter{
	opacity: 0;
	transform: translateY(-200px);
}
.upDown-leave-to{
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/treeMenu/treeMenu.vue